<template>
    <div>
        <hts-slide-over
            :show="props.show"
            :title="$t('labels.supplyPlugin.title')"
            width="50%"
            @close="closeOverSide">
            <template #body>
                <hts-card>
                    <template #toolbar>
                        <div class="w-full text-right">
                            <hts-form-button
                                v-if="group.isAdmin || permissions.includes('supply_plugin_add')"
                                type="submit"
                                icon-name="hi-plus-circle-icon"
                                icon-position="right"
                                @click="onCreateSupplyPlugin">
                                {{ $t('labels.add') }}
                            </hts-form-button>
                        </div>
                    </template>
                    <div>
                        <hts-data-table
                            ref="tableSupplyPlugin"
                            :headers="supplyPluginHeader"
                            :server="getApi"
                            :get-context-menu-items="getContextMenuItems" />
                    </div>
                </hts-card>
            </template>
            <template #footer>
                <div />
            </template>
        </hts-slide-over>
        <supply-plugins-editor
            v-if="showPluginEditor"
            :show="showPluginEditor"
            :action="supplyPlugin"
            :plugin-data="pluginSelected"
            @close="showPluginEditor = false"
            @on-submit="onSubmitData" />
        <hts-modal
            :show="showModalDelete"
            :title="$t('labels.deleteSupplyPlugin')"
            type="confirm"
            :content="$t('labels.confirmDeleteSupplyPlugin')"
            @hide="onCloseModal"
            @confirm="() => onDelete(idsDelete)" />
    </div>
</template>
<script lang="ts" setup>
import { ESupplyStatus, ISupplyPlugin } from '../models/supply'
import { onHanlderStatus } from '../service/helper'
import SupplyPluginsEditor from './supply-plugins-editor.vue'

const store = $store()
const group = store.system.getGroup
const permissions = ref<Array<String>>([])
onMounted(() => {
  permissions.value = group.permissions
})
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  id: {
    type: String,
    default: '',
    required: true
  }
})
const emits = defineEmits(['close'])
const supplyPluginHeader = [
  {
    field: 'name',
    headerName: $t('labels.supplyPlugin.name'),
    minWidth: 200,
    sortable: true
  },
  {
    field: 'description',
    headerName: $t('labels.supplyPlugin.description'),
    minWidth: 200,
    sortable: true
  },
  {
    field: 'status',
    headerName: $t('labels.supplyPlugin.status'),
    valueGetter: (params: any) => {
      return onHanlderStatus(params.data.status)
    },
    minWidth: 200,
    sortable: true
  }
]

const supplyPluginDefault: ISupplyPlugin = {
  ID: '',
  supply: '',
  plugin: '',
  name: '',
  status: ESupplyStatus.DEFAULT,
  description: ''
}

const pluginSelected: ISupplyPlugin = reactive({ ...supplyPluginDefault })

const showPluginEditor = ref(false)
const supplyPlugin = ref('create')
const tableSupplyPlugin = ref()
const showModalDelete = ref(false)
const idsDelete = ref<string[]>([])

const onConfirmDelete = (ids: string[]) => {
  showModalDelete.value = true
  idsDelete.value = ids
}

const onCloseModal = () => {
  showModalDelete.value = false
}

const getId = computed(() => {
  return props.id
})

const getApi = computed(() => {
  const url = $url.supply.plugins.supplyPluginListById
  const temp = Object.assign({}, url)
  temp.url = temp.url.replace('ID', props.id)
  return temp
})

const closeOverSide = () => {
  emits('close')
}

const onCreateSupplyPlugin = () => {
  supplyPlugin.value = 'create'
  Object.assign(pluginSelected, { ...supplyPluginDefault })
  showPluginEditor.value = true
}

const getContextMenuItems = (params: any) => {
  if (params.node && params.node.data) {
    const menuItem = [
      group.isAdmin || permissions.value.includes('supply_plugin_edit')
        ? {
          name: $t('labels.supplyPlugin.edit'),
          action: () => {
            pluginSelected.ID = params.node.data.id
            pluginSelected.supply = params.node.data.supply
            pluginSelected.plugin = params.node.data.plugin
            pluginSelected.status = params.node.data.status
            pluginSelected.name = params.node.data.name
            pluginSelected.description = params.node.data.description
            supplyPlugin.value = 'edit'
            showPluginEditor.value = true
          }
        }
        : null,
      group.isAdmin || permissions.value.includes('supply_plugin_delete')
        ? {
          name: $t('labels.supplyPlugin.delete'),
          action: () => {
            const ids = [params.node.data.id]
            onConfirmDelete(ids)
          }
        }
        : null
    ]
    return menuItem
  }
  return []
}

const onSubmitData = $lodash.debounce(async (data: any, action: string) => {
  const url = action === 'create' ? $url.supply.plugins.supplyPluginCreate : $url.supply.plugins.supplyPluginUpdate
  if (action === 'create') {
    data.supply = getId.value
    data.plugin = getId.value
  }
  const result = await $api(url, { body: new URLSearchParams(data) })
  const success = $lodash.get(result, 'data.value.success')
  const error = $lodash.get(result, 'data.value.data')
  if (success) {
    if (action === 'create') {
      $toast().success($t('labels.createSussess'))
    }
    if (action === 'edit') {
      $toast().success($t('labels.updateSuccess'))
    }
    tableSupplyPlugin.value.refresh()
    showPluginEditor.value = false
  } else {
    process.client && $toast().error(error.errors[0].msg)
  }
}, 500)

const onDelete = $lodash.debounce(async (ids: String[]) => {
  const url = $url.supply.plugins.supplyPluginDelete
  const result = await $api(url, { body: { ids } })
  const success = $lodash.get(result, 'data.value.success')
  const error = $lodash.get(result, 'data.value.data')
  if (success) {
    $toast().success($t('labels.deleteSuccess'))
    tableSupplyPlugin.value.refresh()
    onCloseModal()
  } else {
    $toast().error(error)
  }
})
</script>
